
const Loader = () => (
    <div className="">
      <img
        src={"/gifs/Animation - 1702974649097.gif"}
        alt="loader"
      
        className="animate-spin"
      />
    </div>
  );
  
  export default Loader;